import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=15b5c35c&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=15b5c35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5c35c",
  null
  
)

export default component.exports